const strings= {
  appname: "advance-demo",
  home: "Home",
  form: "Form details",
  login: "Admin Login",
  listing: "Demo Requests",
  notfound: "Not Found"
}

export default strings